import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {FusePageSimple, FuseAnimate} from '@fuse';

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';
import { Paper, Grid, Chip, Card, CardHeader, Divider, CardContent, Typography, List, ListItem, ListItemText, ListItemIcon, ListItemAvatar, IconButton, CircularProgress } from '@material-ui/core';
import Pagination from "material-ui-flat-pagination";
import HomeIcon from '@material-ui/icons/Home';

import StarsIcon from '@material-ui/icons/Stars';
import MoreVertIcon from '@material-ui/icons/MoreVert';

const styles = theme => ({
    layoutRoot: {},
    kemajuanTotal: {
        textAlign: 'center',
        minHeight: 100
    },
    pagingPeringkat: {
        textAlign: 'right'
    },
    facebook2: {
        color: '#eef3fd',
        animationDuration: '550ms',
        position: 'absolute',
        // left: 0,
    },
    facebook: {
        color: '#00C853',
        // animationDuration: '550ms',
        // position: 'absolute',
        // left: 0,
    },
    judulKemajuanTotal : {
        fontSize: '18px'
    },
});

class Validasi extends Component {

    state = {
        error: null,
        routeParams: {
            sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id,
            token: localStorage.getItem('jwt_token'),
            start: 0,
            limit: 20,
            tahun: localStorage.getItem('tahun'),
        },
        kemajuan_total: 0,
        offset: 0,
        total: 100
    }

    goTolink = (url) => {
        this.props.history.push(url);
    };

    loadData = (e, offset) => {
        this.props.setLoading('block');
        this.setState({
            ...this.state,
            offset: offset,
            routeParams: {
                ...this.state.routeParams,
                start: offset
            }
        },()=>{
            // // dikomen dulu biar nggak berat
            this.props.getPeringkatPengisian(this.state.routeParams).then((result)=>{
                // console.log(this.props.peringkat_pengisian);
                this.setState({
                    ...this.state,
                    total: this.props.peringkat_pengisian.total
                });
                this.props.setLoading('none');
            });
        });

    }

    componentDidMount = () => {
        this.props.setLoading('block');

        this.props.setJudul('Peringkat Pengisian');

        this.props.getKemajuanTotal(this.state.routeParams).then((result)=>{
            // console.log(this.props.kemajuan_total);
            // this.props.kemajuan_total.rows.map((option)=>{
            //     if(option.peran_id === 99){
            //         this.setState({
            //             ...this.state,
            //             kemajuan_total: option.persentase
            //         });
            //     }
            // });

            const array = this.props.kemajuan_total.rows;
            for (let index = 0; index < array.length; index++) {
                const element = array[index];
                
                if(element.peran_id === 99){
                    this.setState({
                        ...this.state,
                        kemajuan_total: element.persentase
                    });
                }
            }

            this.props.getPeringkatPengisian(this.state.routeParams).then((result)=>{
                // console.log(this.props.peringkat_pengisian);
                this.setState({
                    ...this.state,
                    total: this.props.peringkat_pengisian.total
                });

                this.props.setLoading('none');
            });
        });
    }

    render()
    {
        const {classes, kemajuan_total} = this.props;

        return (
            <FusePageSimple
                classes={{
                    root: classes.layoutRoot
                }}
                content={
                    <FuseAnimate
                        animation="transition.slideRightBigIn"
                        duration={400}
                        delay={400}
                    >
                    <div style={{width: '100%'}} className="konten-utama">
                        {/* <div className="p-16" style={{border: '0px solid #ccc', width: '100%', background: 'url(http://pmp.dikdasmen.kemdikbud.go.id:1745/assets/images/backgrounds/kemajuan.png)', marginTop: '-1px', backgroundPosition: 'center', backgroundSize: 'contain', minHeight: 89, backgroundAttachment: 'fixed'}}>
                            <Grid container spacing={16}>
                                <Grid item xs={12} sm={9} style={{paddingLeft: 10}}>
                                    <h1 style={{fontSize: 25, fontFamily: 'Helvetica', color: 'white'}}>Peringkat Pengisian Kuesioner</h1>
                                </Grid>
                            </Grid>
                        </div> */}
                        <div style={{minHeight: 10, width: '100%', background: '#4EBBE8', overflow: 'auto', maxHeight: '42px', display: 'inline-flex'}}>
                            <Chip
                                icon={<HomeIcon/>}
                                label=""
                                className={this.props.classes.chip}
                                color="primary"
                                style={{justifyContent: 'start', marginLeft: 0, padding: 5, borderRadius: 0, borderRight: '1px solid #ccc', paddingLeft: '0px', paddingRight: '0px'}}
                                onClick={()=>{this.goTolink('/Beranda')}}
                                />
                            <Chip
                                label="> Peringkat Pengisian Kuesioner"
                                className={this.props.classes.chip}
                                color="secondary"
                                onClick={()=>{this.goTolink('/KonfirmasiSelesai')}}
                                style={{justifyContent: 'start', marginRight: 0, padding: 5, borderRadius: 0, paddingLeft: 0, paddingRight: 0, fontSize: 12}}
                            />
                        </div>
                        <Paper className="p-8">
                            <Grid container spacing={8}>
                                <Grid item xs={12} sm={6}>
                                    <Paper style={{minHeight: 400}}>
                                        <List component="nav">
                                            <ListItem>
                                                <ListItemText primary={<Typography variant="title" style={{color:'#007AFF'}}>Kemajuan per Jenis Responden</Typography>}/>
                                            </ListItem>
                                            <Divider/>
                                            {/* <ListItem color="primary">
                                                <ListItemText primary="Kemajuan per Kategori" />
                                            </ListItem> */}
                                            {
                                            kemajuan_total.rows
                                            .filter(option => option.peran_id !== 99 && option.peran_id !== 13)
                                            .map((option, key)=>{

                                                // if(option.peran_id !== 99 && option.peran_id !== 13){

                                                    return (
                                                        <div key={key}>
                                                            <ListItem button>
                                                                <ListItemText 
                                                                    primary={<b>{option.nama}</b>}
                                                                    secondary={<Typography style={{fontSize:'12px'}}>Jumlah minimal responden: <b>{option.total}</b><br/>Jumlah responden selesai: <b>{option.selesai}</b></Typography>}
                                                                />
                                                                <ListItemAvatar>
                                                                    <Typography variant="subheading"><b>{option.persentase}%</b></Typography>
                                                                </ListItemAvatar>
                                                            </ListItem>
                                                            <Divider/>
                                                        </div>
                                                        
                                                        // <ListItem button>{option.nama}</ListItem>
                                                    )
                                                // }

                                            })} 
                                        </List>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    {/* <Paper className={classes.kemajuanTotal} style={{minHeight: '220px'}}> */}
                                        {/* <Typography className="p-16" variant="title">Kemajuan Total</Typography>
                                        <Typography variant="display3">{this.state.kemajuan_total}%</Typography>
                                        <Typography className="p-16" variant="caption">*Dihitung dari kemajuan pengisian responden, dibandingkan dengan jumlah minimal setiap jenis responden yang harus mengisi</Typography> */}
                                        {/* <div style={{fontSize: 45, color: '#434343', position: 'absolute', top: '35%', margin: 'auto', textAlign: 'center', width: '100%'}}>{this.state.kemajuan_total}%</div>
                                        <CircularProgress
                                        // className={classes.progress}
                                        variant="determinate"
                                        value={100}
                                        size={205}
                                        thickness={6}
                                        className={classes.progress+" "+classes.facebook2}
                                        />
                                        <CircularProgress
                                        className={classes.progress}
                                        variant="determinate"
                                        value={this.state.kemajuan_total}
                                        variant="static"
                                        size={205}
                                        thickness={6}
                                        // className={classes.facebook2}
                                        /> */}
                                    {/* </Paper> */}
                                    <Card className={this.props.classes.card} style={{width: '100%', background: 'transparent', paddingBottom: 5, backgroundColor: 'rgba(255, 255, 255, 1)', minHeight: 400, color: 'white', textAlign: 'center'}}>
                                        <CardHeader title="Kemajuan Pengisian Keseluruhan" classes={{title : classes.judulKemajuanTotal}} style={{fontSize: '18px'}}/>
                                        <Divider/>
                                        <CardContent>
                                            <List button style={{width: '100%'}}>
                                                <div style={{fontWeight:'bold', fontSize: 45, color: '#434343', position: 'absolute', top: '35%', margin: 'auto', textAlign: 'center', width: '100%'}}>{this.state.kemajuan_total}%</div>
                                                <CircularProgress
                                                // className={classes.progress}
                                                variant="determinate"
                                                value={100}
                                                size={205}
                                                // thickness={6}
                                                className={classes.progress+" "+classes.facebook2}
                                                />
                                                <CircularProgress
                                                // className={classes.progress}
                                                variant="determinate"
                                                value={this.state.kemajuan_total}
                                                variant="static"
                                                size={205}
                                                thickness={6}
                                                className={classes.facebook}
                                                />
                                            </List>
                                            {/* <Typography style={{fontSize: 17, color: '#434343'}}>Kemajuan Total</Typography> */}
                                            <Typography className="p-16" variant="caption">*Dihitung dari kemajuan pengisian responden, dibandingkan dengan jumlah minimal setiap jenis responden yang harus mengisi</Typography>
                                            {/* <Button size="small" style={{background: '#1abc9c', color: 'white', width: '100%'}} onClick={this.buatSekolahButton}>
                                                <ListIcon className={this.props.classes.extendedIcon} style={{color: 'white'}} />
                                                <Typography style={{color: 'white', paddingLeft: '10px'}}>Selengkapnya</Typography>
                                            </Button> */}

                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <Paper>
                                        <Grid container>
                                            <Grid item xs={10}>
                                                <Typography className="p-16" variant="title">Peringkat Pengisian Per Responden</Typography>
                                            </Grid>
                                            <Grid item xs={2} style={{textAlign: 'right'}}>
                                                <IconButton>
                                                    <MoreVertIcon/>
                                                </IconButton>
                                            </Grid>
                                        </Grid>
                                        <Paper className={classes.pagingPeringkat}>
                                            <Pagination
                                                limit={20}
                                                offset={this.state.offset}
                                                total={this.state.total}
                                                innerButtonCount={1}
                                                style={{width: '100%'}}
                                                onClick={this.loadData}
                                            />
                                        </Paper>
                                        <List component="nav">
                                            {this.props.peringkat_pengisian.rows.length < 1 && <Typography variant="subheading" style={{fontStyle:'italic',color: '#959595', textAlign: 'center', marginTop: 10, marginBottom: 10}}>Belum ada responden yang mengerjakan</Typography>}
                                            {this.props.peringkat_pengisian.rows.map((option, key)=>{

                                                let colorPersen = '#558B2F';

                                                if(option.persentase < 30){
                                                    colorPersen = '#E65100';
                                                }else if(option.persentase < 50){
                                                    colorPersen = '#FB8C00';
                                                }else if(option.persentase < 70){
                                                    colorPersen = '#827717';
                                                }

                                                return (
                                                    <ListItem button key={key}>
                                                        <ListItemText primary={option.nama} secondary={<div><Typography variant="body2" style={{color: '#7CB342', fontSize: '13px'}}>{option.email + " - " + option.peran}</Typography><Typography variant="caption" style={{color: '#C5E1A5'}}>Terakhir mengerjakan: {option.tanggal_rekap_terakhir}</Typography></div>}/>
                                                        {option.urutan === 1 && (<ListItemIcon>
                                                            <StarsIcon style={{color: '#0091EA'}}/>
                                                        </ListItemIcon>)
                                                        }
                                                        <ListItemAvatar>
                                                            <Typography variant="subheading" style={{color: colorPersen, fontWeight: 'bolder'}}>{option.persentase}%</Typography>
                                                        </ListItemAvatar>
                                                    </ListItem>
                                                )
                                            })}
                                            <Divider/>
                                            {/* <ListItem button color="primary">
                                                <ListItemText primary="Selengkapnya" />
                                            </ListItem> */}
                                        </List>
                                        <Paper className={classes.pagingPeringkat}>
                                            <Pagination
                                                limit={20}
                                                offset={this.state.offset}
                                                total={this.state.total}
                                                innerButtonCount={1}
                                                style={{width: '100%'}}
                                                onClick={this.loadData}
                                            />
                                        </Paper>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Paper>
                    </div>
                    </FuseAnimate>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getSekolah: Actions.getSekolah,
        setKunciKonfirmasiInstrumen: Actions.setKunciKonfirmasiInstrumen,
        getKonfirmasiSelesai: Actions.getKonfirmasiSelesai,
        getKemajuanTotal: Actions.getKemajuanTotal,
        getPeringkatPengisian: Actions.getPeringkatPengisian,
        setLoading: Actions.setLoading,
        setJudul: Actions.setJudul
    }, dispatch);
}

function mapStateToProps({ Sekolah, Instrumen }) {

    return {
        sekolah: Sekolah.sekolah,
        konfirmasi_instrumen_id: Instrumen.konfirmasi_instrumen_id,
        konfirmasi_instrumen: Instrumen.konfirmasi_instrumen,
        kemajuan_total: Instrumen.kemajuan_total,
        peringkat_pengisian: Instrumen.peringkat_pengisian
    }
}

// export default withStyles(styles, {withTheme: true})(Beranda);
export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Validasi)));




// WEBPACK FOOTER //
// ./src/main/content/Validasi/Validasi.js